import { index, Options } from 'shared/assets/styles';
import { Datepicker } from 'shared/components/ui/datepicker';
import styled from 'styled-components';

export const StyledDatepicker = styled(Datepicker)`
  z-index: ${index(Options.TOOLTIP)};
`;
